export const GoogleMapApiConfig = 'AIzaSyBcPfDt1RL6oS-Ds0HEuU7IIibhrsGE2ak';